import Equipments from '@/pages/admin/Equipments';

/** Equipamentos do personal: globais + próprios (scope=all), cria os próprios. */
export default function TrainerEquipments() {
  return <Equipments mode="library" />;
}
